import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { volumes, volumeIncludes } from '../data/volumes';
export function Volumes() {
  return <section aria-label="System contents" className="bg-transparent" data-id="element-306" data-mp="183vk6makcttz">
      <div className="mx-auto max-w-6xl px-5 py-12" style={{
      paddingTop: '19px',
      paddingBottom: "21px"
    }} data-id="element-307" data-mp="185q3jw66sdvy">
        <div className="text-center" data-id="element-308" data-mp="1zv1m989uh1lw">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-grape" data-id="element-309" data-mp="1zw4bzcvfky08">
            Introducing the 100+ AI Prompts for Supervisors™
          </p>
          <h2 className="mt-3 font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-310" data-mp="1qud8meod539j">
            📚 The 6-Volume Supervisory Toolkit
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-plum/70" data-id="element-311" data-mp="1vs4y721jcdak">
            A structured collection of AI prompts organized into six practical volumes, with five complementary resources to help you apply the system to your daily work. Each volume focuses on a different area of supervisory responsibility, helping you choose a relevant prompt for the task at hand.
          </p>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-312" data-mp="3jawp6aasoca7">
          {volumes.map((t, i) => <motion.article key={t.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i % 3 * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-2xl border border-grape-soft/40 bg-white p-5" data-id="element-313" data-mp="22jgnduofuha" data-mpi={i}>
              <div className="flex items-start gap-3" data-id="element-314" data-mp="ktami5fgh2qx">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-plum font-display text-lg font-black text-grape-soft" data-id="element-315" data-mp="fto83snw5ggj">
                  {String(t.n).padStart(2, '0')}
                </span>
                <div className="min-w-0" data-id="element-316" data-mp="pog790x4gbdf">
                  <h3 className="text-sm font-bold leading-tight text-plum" data-id="element-317" data-mp="wu97qj8sspi9">{t.title}</h3>
                  <p className="mt-1 text-xs font-bold uppercase tracking-wide text-grape" data-id="element-318" data-mp="11skgeqncwtyw">{t.subtitle}</p>
                </div>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-plum/65" data-id="element-319" data-mp="16qcb1sfdyu6s">{t.desc}</p>
            </motion.article>)}
        </div>

        <div className="mt-10 rounded-2xl border border-grape-soft/50 bg-white p-6" data-id="element-320" data-mp="1bkghmakqp07c">
          <p className="text-center font-display text-lg font-black text-plum" data-id="element-321" data-mp="1fjz43as7ljca">
            ✅ Every Volume Includes
          </p>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-322" data-mp="1pierb2o488gi">
            {volumeIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-plum/75" data-id="element-323" data-mp="1pgka9zfyt0hp">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-324" data-mp="1ufezbj4izla9" />
                {item}
              </li>)}
          </ul>
          
        </div>
      </div>
    </section>;
}